import { useEffect } from "react";

let lockCount = 0;
let originalOverflow = "";

/**
 * 모달/팝업 열림 동안 배경(body) 스크롤 잠금.
 *  - locked 가 true 인 동안 body overflow: hidden.
 *  - 이전 값을 저장/복원해 중첩(모달 위 모달)에도 안전.
 *
 *   useBodyScrollLock(isShow);
 */
export default function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    if (lockCount === 0) originalOverflow = document.body.style.overflow;
    lockCount += 1;
    document.body.style.overflow = "hidden";
    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) document.body.style.overflow = originalOverflow;
    };
  }, [locked]);
}
